// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.ReferenceTuple
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { KendoObservableObjectProxy } from "abweb/dto/kendo/KendoObservableObjectProxy";
export class ReferenceTupleBase extends KendoObservableObjectProxy {
  /** Do NOT invoke directly, instead use strongly typed createReferenceTupleBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.ReferenceTuple";
  }
  initFromJson(json, deserializeContext) {
    this.initReferenceTuple(json.displayValue != null ? json.displayValue : null, json.value != null ? json.value : null);
  }
  initReferenceTuple(displayValue, value) {
    this.initKendoObservableObjectProxy();
    this._displayValue = displayValue;
    this._value = value;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (this._displayValue != null) {
      retVal["displayValue"] = this._displayValue;
    }
    if (this._value != null) {
      retVal["value"] = this._value;
    }
    return retVal;
  }
  get displayValue() {
    return this._displayValue;
  }
  set displayValue(value) {
    this._displayValue = value;
  }
  get value() {
    return this._value;
  }
  set value(value) {
    this._value = value;
  }
}
//# sourceMappingURL=ReferenceTupleBase.js.map
